import { useSelector } from 'react-redux';
import { site, customization } from '@yola/ws-sdk';

const useTextDecorations = () => {
  const rawDecorations = useSelector(customization.selectors.getTextDecorations);
  const decorations = rawDecorations
    .filter((decoration) => !decoration.disabled)
    .map((decoration) => ({
      ...decoration,
      previewUrl: site.helpers.composeAssetUrl(decoration.previewUrl),
    }));

  const getDecorationById = (id) => decorations.find((decoration) => decoration.id === id);

  return {
    decorations,
    getDecorationById,
  };
};

export default useTextDecorations;
